var map = {
	"./ai.svg": 463,
	"./cancel.svg": 464,
	"./cdr.svg": 465,
	"./classify.svg": 466,
	"./clear.svg": 467,
	"./client.svg": 468,
	"./customer.svg": 469,
	"./download.svg": 470,
	"./empty.svg": 471,
	"./error.svg": 472,
	"./fileUpload.svg": 473,
	"./folder.svg": 474,
	"./folderUpload.svg": 475,
	"./foldermenu.svg": 476,
	"./full.svg": 477,
	"./home.svg": 478,
	"./loading.svg": 479,
	"./menu.svg": 480,
	"./move.svg": 481,
	"./network.svg": 482,
	"./password.svg": 483,
	"./pdf.svg": 484,
	"./plus.svg": 485,
	"./ppt.svg": 486,
	"./psd.svg": 487,
	"./recycle.svg": 488,
	"./reduce.svg": 489,
	"./resource.svg": 490,
	"./role.svg": 491,
	"./success.svg": 492,
	"./system.svg": 493,
	"./tif.svg": 494,
	"./unknown.svg": 495,
	"./upload.svg": 496,
	"./user.svg": 497,
	"./word.svg": 498,
	"./xls.svg": 499,
	"./zip.svg": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;